<template>
  <div>
    <v-app-bar
      app
      :color="mapEnvAppColor"
      light
      clipped-left
      class="app-bar"
    >
      <v-col>
        <h3 class="text-h6" v-if="$route.name === 'contracts'">{{mapEnvAppName}}</h3>
        <v-menu
          ref="contractMenu"
          v-model="contractMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto"
          v-if="isContractMenuShown"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-chip
              v-on="on"
              v-bind="attrs"
            >
              {{ badgeText }}
              <v-icon
                right
                v-if="contract.contractName"
              >
                {{ contractMenu ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
              </v-icon>
            </v-chip>
          </template>
          <contract-menu v-if="contract.contractName" :contract="contract" />
        </v-menu>
        <v-spacer />
      </v-col>
      <div class="app-bar-logo-center d-none d-md-flex">
        <v-img
          alt="Vattenfall Logo"
          contain
          src="../assets/logo.svg"
          transition="scale-transition"
          max-height="50px"
          max-width="150px"
          @click="navigateToContracts"
        />
      </div>
      <MenuDropdown />
      <template v-slot:extension v-if="this.$slots.extension">
        <slot name="extension"/>
      </template>
    </v-app-bar>
    <progress-bar
      :loading="isFetching"
      :progressBarStyle="{ top: this.$slots.extension ? '112px' : '64px', zIndex: 500 }"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { isFetching } from '@/store/getters'
import { DEFAULT_CONTRACT, mapEnvAppColor, mapEnvAppName } from '@/helpers'

export default {
  name: 'ContractBar',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    contract: {
      type: Object,
      default: () => DEFAULT_CONTRACT
    }
  },
  data () {
    return {
      contractMenu: false
    }
  },
  computed: {
    mapEnvAppColor,
    mapEnvAppName,
    ...mapGetters([isFetching]),
    contractCurrency () {
      return this.contract.chosenCurrency
    },
    userName () {
      return this.auth.account?.name
    },
    badgeText () {
      return this.contract.contractName
        ? `${this.contract.contractName} (${this.contractCurrency.key})`
        : this.$t('common.noContract')
    },
    isContractMenuShown () {
      return this.$slots.extension && this.$router.currentRoute.path.includes('contracts')
    }
  },
  methods: {
    navigateToContracts () {
      if (this.$route.name !== 'contracts') {
        this.$router.push({ name: 'contracts' })
      }
    }
  }
}
</script>

<style scoped>
.app-bar-logo-center {
  position: absolute;
  left: 50%;
  top: 0;
  height: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
  transform: translateX(-50%);
  z-index: 1;
}
</style>
